import { useLanguage } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { copy } = useLanguage();
  const items = [...copy.marquee, ...copy.marquee];
  return (
    <div className="relative overflow-hidden bg-gold-light py-4 select-none border-y border-gold/20" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track flex w-max animate-marquee gap-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 text-pine/80 font-serif italic text-lg whitespace-nowrap">
            {item}
            <span className="h-1.5 w-1.5 rounded-full bg-clay inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
